const saleItemElement = document.getElementById('modal');
const button = document.getElementById('addSaleItem');
saleItemElement.style.display = 'none';

document.getElementById('addSaleItem').addEventListener('click', function () {
  saleItemElement.style.display = 'block';
});

document.getElementById('test-sale-item-element').addEventListener('closeSaleItemModal', function(event) {
  saleItemElement.style.display = 'none';
});

document.getElementById('test-sale-item-element').addEventListener('success', function(event) {
  console.log('success', event);
});
